import WebApp from '@twa-dev/sdk';
import type { LanguageCode } from '../types/i18n';

const VALID_CODES: LanguageCode[] = ['uz', 'ru', 'en'];
const STORAGE_KEY = 'preferredLanguage';

export function detectInitialLanguage(
  supportedLanguages: LanguageCode[],
  defaultLanguage: LanguageCode,
  preferredLanguage?: LanguageCode | null,
): LanguageCode {
  const supported = supportedLanguages.length > 0 ? supportedLanguages : VALID_CODES;

  // 0. Server-persisted user preference — highest priority
  if (
    preferredLanguage &&
    VALID_CODES.includes(preferredLanguage) &&
    supported.includes(preferredLanguage)
  ) {
    return preferredLanguage;
  }

  // 1. Telegram user language
  try {
    const tgLang = WebApp.initDataUnsafe?.user?.language_code;
    if (typeof tgLang === 'string') {
      const base = tgLang.split('-')[0].toLowerCase() as LanguageCode;
      if (VALID_CODES.includes(base) && supported.includes(base)) {
        return base;
      }
    }
  } catch {
    // WebApp may not be available in non-Telegram environments
  }

  // 2. localStorage preference
  try {
    const stored = localStorage.getItem(STORAGE_KEY) as LanguageCode | null;
    if (stored && VALID_CODES.includes(stored) && supported.includes(stored)) {
      return stored;
    }
  } catch {
    // localStorage may not be available
  }

  // 3. Tenant default or first supported
  if (supported.includes(defaultLanguage)) {
    return defaultLanguage;
  }
  return supported[0] ?? 'uz';
}

export function persistLanguage(lang: LanguageCode): void {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    // ignore
  }
}
